import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function Info($$anchor, $$props) {
	const iconNode = [
		["circle", { "cx": "12", "cy": "12", "r": "10" }],
		["path", { "d": "M12 16v-4" }],
		["path", { "d": "M12 8h.01" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiSW5mby5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IEljb24gZnJvbSAnLi9JY29uLnN2ZWx0ZSc7XG4gIGNvbnN0IGljb25Ob2RlOiBbc3RyaW5nLCBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+XVtdID0gW1tcImNpcmNsZVwiLCB7IFwiY3hcIjogXCIxMlwiLCBcImN5XCI6IFwiMTJcIiwgXCJyXCI6IFwiMTBcIiB9XSwgW1wicGF0aFwiLCB7IFwiZFwiOiBcIk0xMiAxNnYtNFwiIH1dLCBbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTEyIDhoLjAxXCIgfV1dO1xuICBsZXQgcmVzdCA9ICRwcm9wcygpO1xuPC9zY3JpcHQ+XG48SWNvbiB7aWNvbk5vZGV9IHsuLi5yZXN0fSAvPlxuIl0sIm1hcHBpbmdzIjoiOztPQUNTLElBQUksTUFBTSxlQUFlOztnREFEbEMsQ0FBQztPQUVPLFFBQTRDO0dBQUssUUFBUSxJQUFJLElBQUksRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxHQUFHLEVBQUUsSUFBSTtHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsV0FBVztHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsV0FBVzs7O0tBQ2hLLElBQUk7Ozs7Ozs7O1FBRVcsSUFBSTs7QUFEMUIsQ0FBQyJ9